module.exports = __webpack_public_path__ + "img/ksh12.4c128897.png";